import NotificationIcon from "@assets/icons/notification.svg";
import { notificationBadgeManager } from "@core/service-container";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { isNotNil } from "@utils/assert";
import React from "react";

export const NotificationToastContent = ({
	message,
	onClick,
}: {
	message: string;
	onClick?: () => void;
}): JSX.Element => (
	<Container
		onClick={() => {
			notificationBadgeManager.saveLastUnreadCount();
			if (isNotNil(onClick)) {
				onClick();
			}
		}}
	>
		<div>
			<NotificationIcon color={colors.primary} width={24} height={24} />
		</div>
		<div>{message}</div>
	</Container>
);
const Container = styled.div`
	display: flex;
	flex: 1;
	cursor: pointer;
	gap: 8px;
	color: ${colors.black};
`;
